import { useEffect, useState } from "react";
import { Link } from "wouter";

const DISMISS_KEY = "lakewood_first_timer_banner_dismissed";

export default function FirstTimerBanner() {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    setVisible(window.sessionStorage.getItem(DISMISS_KEY) !== "1");
  }, []);

  if (!visible) return null;

  return (
    <aside aria-label="New patient guidance" style={{ background: "#f3ece3", borderBottom: "1px solid #e7d9ca", color: "#4a6058", position: "relative", zIndex: 1 }}>
      <div style={{ alignItems: "center", display: "flex", gap: ".7rem", justifyContent: "center", margin: "0 auto", maxWidth: 1180, padding: ".62rem 3rem .62rem 1rem", textAlign: "center" }}>
        <span style={{ fontSize: ".8rem", lineHeight: 1.4 }}>First time here? We&apos;ll match you with the right technology.</span>
        <Link href="/ai-skin-analysis" style={{ color: "#5B7A9E", fontSize: ".78rem", fontWeight: 800, textDecoration: "none", whiteSpace: "nowrap" }}>Take the 60-sec free skin analysis →</Link>
        <button type="button" aria-label="Dismiss first-time visitor message" onClick={() => { window.sessionStorage.setItem(DISMISS_KEY, "1"); setVisible(false); }} style={{ background: "transparent", border: 0, color: "#4a6058", cursor: "pointer", fontSize: "1.35rem", lineHeight: 1, padding: ".25rem", position: "absolute", right: "max(1rem, calc((100% - 1180px) / 2))" }}>×</button>
      </div>
      <style>{`@media (max-width: 640px){[aria-label="New patient guidance"] > div{align-items:flex-start;flex-direction:column;gap:.2rem;padding:.62rem 3.25rem .62rem 1rem;text-align:left}[aria-label="New patient guidance"] a{white-space:normal}}`}</style>
    </aside>
  );
}
